import { z } from 'zod';
import { DealActivityEventType } from '@trnsact/trnsact-shared-types';

export const createEventFormSchema = z
  .object({
    notes: z.string(),
    subject: z.string().min(1, 'Subject is required'),
    accountId: z.string().min(1, 'Account is required'),
    contactId: z.string(),
    assignedTo: z.string(),
    priority: z.string().min(1, 'Priority is required'),
    allDay: z.boolean(),
    endAt: z.string().nullable(),
    endDate: z.string().nullable(),
    startAt: z.string().nullable(),
    startDate: z.string().nullable(),
    eventType: z.nativeEnum(DealActivityEventType),
  })
  .superRefine((data, ctx) => {
    if (data.allDay) {
      if (!data.startDate) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start date is required', path: ['startDate'] });
      }

      if (!data.endDate) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date is required', path: ['endDate'] });
      }

      if (data.startDate && data.endDate && new Date(data.endDate) < new Date(data.startDate)) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End date must be after start date', path: ['endDate'] });
      }

      return;
    }

    if (!data.startAt) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Start is required', path: ['startAt'] });
    }

    if (!data.endAt) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End is required', path: ['endAt'] });
    }

    if (data.startAt && data.endAt && new Date(data.endAt) < new Date(data.startAt)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'End must be after start', path: ['endAt'] });
    }
  });

export type CreateEventFormValues = z.infer<typeof createEventFormSchema>;

export const createEventFormDefaultValues: CreateEventFormValues = {
  notes: '',
  endAt: null,
  subject: '',
  allDay: false,
  startAt: null,
  endDate: null,
  accountId: '',
  contactId: '',
  priority: '',
  assignedTo: '',
  startDate: null,
  eventType: DealActivityEventType.Other,
};
